module.exports = __webpack_public_path__ + "static/media/twitter.ed898ded.svg";